module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))]), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("在每一屆 WirForce 中，我們都會訂立些指標性的成就，為了記錄這些歷經艱辛留名 WirForce 歷史的勇者們，我們以崇敬的心將他們銘刻在這「榮譽英雄牆」上，讓世人傳唱勇者們的榮譽事蹟……這些獎項看似惡搞，卻都存在著團隊合作、自律管理、以及挑戰自我的理念，也代表了現場所有參與的 BYOC 玩家精神")])]), _c('div', {
    staticClass: "mb-5"
  }), _c('section'), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("2017")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("大會成就獎")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero1701.png")
    }
  })]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("Fight 賽事成就獎")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero1702.png")
    }
  })]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("活動成就獎")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero1703.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("2016")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("WirForce 2016 大會成就獎")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero01.png")
    }
  })]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("WirForce 2016 BYOC 社群活動成就獎")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero02.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("2015")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("WirForce 2015 特殊成就")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero03.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("2014")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("WirForce 2014 現場賽事")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero04.png")
    }
  })]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("WirForce 2014 特殊成就")])]), _c('img', {
    attrs: {
      "src": require("assets/hero/hero05.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfc4add4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hero.vue
// module id = 585
// module chunks = 1